import React from "react";
import { 
  FaInstagram, 
  FaFacebookF, 
  FaLinkedinIn, 
  FaMapMarkerAlt, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaGlobe 
} from "react-icons/fa";
import "./Contact.css";

export default function Contact() {
  return (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <p>We would love to hear from you! Reach us directly or use the form.</p>

      <div className="contact-content">
        {/* Left side - Company Info */}
        <div className="contact-info">
          <h3>Company Info</h3>

          <div className="info-item">
            <FaMapMarkerAlt className="icon"/>
            <div>
              <strong>Address:</strong> <br/>
              123 Beauty Street, Pune, India
            </div>
          </div>

          <div className="info-item">
            <FaPhoneAlt className="icon"/>
            <div>
              <strong>Phone:</strong> <br/>
              <a href="tel:+919876543210">+91 98765 43210</a>
            </div>
          </div>

          <div className="info-item">
            <FaEnvelope className="icon"/>
            <div>
              <strong>Email:</strong> <br/>
              <a href="mailto:contact@beautysalon.com">contact@beautysalon.com</a>
            </div>
          </div>

          <div className="info-item">
            <FaGlobe className="icon"/>
            <div>
              <strong>Website:</strong> <br/>
              <a href="https://www.beautysalon.com" target="_blank" rel="noopener noreferrer">www.beautysalon.com</a>
            </div>
          </div>

          <h3>Follow Us</h3>
          <div className="icons">
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* Right side - Contact Form */}
        <form className="contact-form">
          <div className="form-group">
            <label>Name</label>
            <input type="text" placeholder="Your Name" />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input type="email" placeholder="Your Email" />
          </div>

          <div className="form-group">
            <label>Phone</label>
            <input type="tel" placeholder="Your Phone Number" />
          </div>

          <div className="form-group">
            <label>Message</label>
            <textarea placeholder="Your Message"></textarea>
          </div>

          <button type="submit" className="submit-btn">Send Message</button>
        </form>
      </div>
    </div>
  );
}
